import { createLogger, ConsoleFormattedStream, stdSerializers } from 'browser-bunyan'
import * as constants from 'view/styles/constants'

const name = 'BrokerTecQuote'

const loggerStyle = {
  levels: {
    info: `color: ${constants.ACCENT_GOOD}`,
    warn: `color: ${constants.ACCENT_BE_AWARE}`,
    error: `color: ${constants.ACCENT_BAD}`
  },
  def: `color: ${constants.ACCENT_PRIMARY}`,
  msg: `color: ${constants.CORE_PRIMARY_6}`
}

export const logger = createLogger({
  name,
  streams: [
    {
      stream: new ConsoleFormattedStream({ logByLevel: true, css: loggerStyle }),
      level: 'info'
    }
  ],
  serializers: stdSerializers
})
